
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import ServicesList from './components/ServicesList';

export default function Services() {
  const { t } = useTranslation('services');

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <ServicesList />
      <Footer />
    </div>
  );
}
